import React from 'react';
import './NewsCard.css';

const NewsCard = ({ noticia }) => {
  const { id, content } = noticia;

  return (
    <div className="news-card">
      {content}
    </div>
  );
};

export default NewsCard;
